import { LuiButton, LuiIcon } from '@linzjs/lui';
import { LuiIconName } from '@linzjs/lui/dist/assets/svg-content';
import { useLayoutEffect, useState } from 'react';

export interface PanelHeaderButtonProps {
  'aria-label': string;
  href?: string;
  icon: LuiIconName;
  onClick?: () => void;
}

export const PanelHeaderButton = ({ 'aria-label': ariaLabel, href, icon, onClick }: PanelHeaderButtonProps) => {
  const [disabled, setDisabled] = useState(true);

  // Dialogs autofocus buttons even when flagged not to
  // On initial display the header buttons are disable to prevent this
  useLayoutEffect(() => {
    // oxlint-disable-next-line react/set-state-in-effect
    setDisabled(false);
  }, []);

  return (
    <LuiButton
      level={'plain-text'}
      className={'lui-button-icon-only'}
      size={'sm'}
      href={href}
      disabled={disabled}
      onClick={onClick}
      openInNewTab={!!href}
      title={ariaLabel}
      buttonProps={{
        onTouchStart: onClick,
        'data-noautofocus': true,
      }}
    >
      <LuiIcon name={icon} alt={ariaLabel} size={'md'} />
    </LuiButton>
  );
};
